module.exports = __webpack_public_path__ + "media/images/icon-benefits-marketplace-b816dae20e585fe1bb15ec20b956b8ba.png";